import styled from 'styled-components';

import color from '../_style/color';

import { Flex } from '../common';

const ProfileNotificationCheckGroup = styled(Flex).attrs(() => ({
  direction: 'column',
  width: '100%',
}))`
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border: none;

  span {
    font-size: 12px;
    font-weight: normal;
    color: ${color.primary};

    border-bottom: 1px solid ${color.gainsboro};

    width: 100%;
  }

  > div {
    border-bottom: 1px solid ${color.gainsboro};
  }
`;

export default ProfileNotificationCheckGroup;
